export default "__VITE_ASSET__CgWaOGM___"